import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {LanguageType} from '../shared/types';

const DESCRIPTION_HEBREW: string[] = [`
כשהשמש שוקעת נשמעות יללות, זוהי שירת התנים הזהובים. הם מקבלים את פניו של הירח המסמל את תחילתו של עוד יום בחייהם העירונים.`,
  `השמורה הסיננתרופית מזמינה אותך לצעוד בעקבות חיות הבר העירוניות בפארק הירקון. בתקוה נפגוש היום את אחד היצורים המרהיבים ששבו אל הפארק לאחר שנים של גלות - התן הזהוב.`,
  `לחוויה מותאמת בחר.י את לשון הפניה.`
];

const DESCRIPTION_ENGLISH: string[] = [
  `When the sun set the howls begin, this is the singing of the Golden Jackals. They welcome the moon that symbolise the beginning of another day in their urban life.`,
  `The Synanthrope Preserve invites you to walk in the paths of the urban wild life that inhabits Yarkon Park.
Hopefully, we are going to encounter one of the marvelous creatures that had returned to the park after years of exile - the Golden Jackal.`
];

@Component({
  selector: 'app-pick-gender-page',
  templateUrl: './pick-gender-page.component.html',
  styleUrls: ['./pick-gender-page.component.scss']
})
export class PickGenderPageComponent implements OnInit, OnChanges {
  /** Language to use in the welcome page. */
  @Input() language: LanguageType = 'hebrew';

  @Output() pikedFemaleEvent = new EventEmitter<boolean>();

  description = DESCRIPTION_HEBREW;

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    this.description = this.language === 'hebrew' ? DESCRIPTION_HEBREW : DESCRIPTION_ENGLISH;
  }

  onFemalePick(): void {
    this.pikedFemaleEvent.emit(true);
  }

  onMalePick(): void {
    this.pikedFemaleEvent.emit(false);
  }

}
